//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { useProductTaggingContext } from '@uia/products/context/ProductTaggingContext';
import { BvProductEditor } from '@uia/products/editor/bv-product-editor/BvProductEditor';
import { CuralateProductEditor } from '@uia/products/editor/curalate-product-editor/CuralateProductEditor';
import { getIsBvProduct } from '@uia/products/utils';

export const ProductEditor = () => {
  const {
    cancelNewSpatialTag,
    selectedProductToEdit: product,
    setIsTaggingProducts,
    setSearchQuery,
    setSelectedProductToEdit,
  } = useProductTaggingContext();

  if (!product) {
    return null;
  }

  const onClose = () => {
    setIsTaggingProducts(false);
    setSelectedProductToEdit(undefined);
    setSearchQuery('');
    cancelNewSpatialTag();
  };

  const isBvProduct = getIsBvProduct(product.productStyleId);

  return (
    <RootContainer>
      {isBvProduct ? (
        <BvProductEditor
          onCancel={onClose}
          onSave={onClose}
          product={product}
        />
      ) : (
        <CuralateProductEditor onClose={onClose} product={product} />
      )}
    </RootContainer>
  );
};

const RootContainer = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[3]};
  `,
);
